import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import authModule from './modules/auth'
import clientsModule from './modules/clients'
import patientsModule from './modules/patients'
import casesModules from './modules/cases'
import pgtCasesModule from './modules/pgtcases'
import batchesModule from './modules/batches'
import servicesModule from './modules/services'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth: {
      ...authModule
    },
    clients: {
      ...clientsModule
    },
    patients: {
      ...patientsModule
    },
    cases: {
      ...casesModules
    },
    pgtCases: {
      ...pgtCasesModule
    },
    batches: {
      ...batchesModule
    },
    services: {
      ...servicesModule
    }
  },
  state,
  actions,
  mutations,
  getters,
  strict: false
})
